import {
  LayoutConfig as ILayoutConfig,
  ReviewsSummaryConfig as IReviewsSummaryConfig,
  SpectrumConfig as ISpectrumConfig
} from 'services/api-service'

export class ReviewsSummaryConfig implements IReviewsSummaryConfig {
  constructor(config: IReviewsSummaryConfig) {
    this.aggregateMetaOn = config.aggregateMetaOn
    this.aggregateJsonLdMetaOn = config.aggregateJsonLdMetaOn
    this.breakpoints = config.breakpoints
    this.childWidgets = config.childWidgets || {}
    this.layouts = config.layouts
    this.showRangeMiddle = config.showRangeMiddle
    this.widgetDivId = config.widgetDivId
  }

  aggregateMetaOn: boolean
  aggregateJsonLdMetaOn: boolean
  breakpoints?: Array <ILayoutConfig>
  childWidgets?: { [name: string]: any } // gallery | spectrum
  layouts ?: Array <ILayoutConfig>
  showRangeMiddle: boolean
  spectrumConfig ?: ISpectrumConfig
  widgetDivId: string
}

let defaultConfig: IReviewsSummaryConfig = {}
export function loadConfig(config: IReviewsSummaryConfig) {
  defaultConfig = new ReviewsSummaryConfig(config)
}

export { defaultConfig as default }



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/widgets/reviews-summary/reviews-summary.config.ts